<template>
  <page>
    <template v-slot:header>
      <CCol xs="12" sm="4" class="offset-sm-4">
        <div class="text-center">
          <h1 class="mb-3 font-5xl">
            {{ $t('faqs.contactUs.header.title') }}
          </h1>
        </div>
      </CCol>
    </template>
    <CCol class="pt-5">
      <MenssageAlert :messages="messages" />
      <CRow>
        <CCol xs="12" sm="12" class="mt-4">
          <div class="col-md-6 offset-md-3 mt-5 mb-5 formBlock">
            <h2 class="formTitle mt-1 mb-5">{{ $t('faqs.contactUs.form.title') }}</h2>
            <CCol sm="12">
              <CInput
                class="mb-0 inputContactForm"
                :label="$t('faqs.contactUs.form.fullName')"
                addLabelClasses="mt-1 "
                :value.sync="$v.contactForm.fullName.$model"
                :isValid="!$v.contactForm.fullName.$anyError"
                :invalidFeedback="$t('faqs.contactUs.form.validation.requiredFieldText')"
              />
            </CCol>
            <CCol sm="12" class="mt-3">
              <CInput
                class="mb-0 inputContactForm"
                :label="$t('faqs.contactUs.form.email')"
                addLabelClasses="mt-1 "
                :value.sync="$v.contactForm.emailAddress.$model"
                :isValid="!$v.contactForm.emailAddress.$anyError"
                :invalidFeedback="
                  !$v.contactForm.emailAddress.required
                    ? $t('faqs.contactUs.form.validation.requiredFieldText')
                    : !$v.contactForm.emailAddress.email
                    ? $t('faqs.contactUs.form.validation.emailField')
                    : $t('faqs.contactUs.form.validation.requiredFieldText')
                "
              />
            </CCol>
            <CCol sm="12" class="mt-3">
              <CInput
                class="mb-0 inputContactForm"
                :label="$t('faqs.contactUs.form.companyName')"
                addLabelClasses="mt-1 "
                :value.sync="$v.contactForm.companyName.$model"
                :isValid="!$v.contactForm.companyName.$anyError"
                :invalidFeedback="$t('faqs.contactUs.form.validation.requiredFieldText')"
              />
            </CCol>
            <CCol sm="12" class="mt-3">
              <CInput
                class="mb-0 inputContactForm"
                :maxlength="30"
                :label="$t('faqs.contactUs.form.phoneNumber')"
                addLabelClasses="mt-1 "
                :value.sync="$v.contactForm.phoneNumber.$model"
                :isValid="!$v.contactForm.phoneNumber.$anyError"
                :invalidFeedback="
                  !$v.contactForm.phoneNumber.required
                    ? $t('faqs.contactUs.form.validation.requiredFieldText')
                    : !$v.contactForm.phoneNumber.numeric
                    ? $t('faqs.contactUs.form.validation.numericFieldText')
                    : $t('faqs.contactUs.form.validation.requiredFieldText')
                "
              />
            </CCol>
            <!-- <CCol sm="12" class="d-flex flex-column">
              <div class="my-2 mt-4">
                <h4 class="topicTitle">{{$t('faqs.contactUs.form.topic') }}</h4>
                <v-select
                  style="border: 1px solid #DEE2E6;"
                  class="mb-0 no-close my-3"
                  :options="topicOptions"
                  v-model="contactForm.topic"
                  :placeholder="$t('faqs.contactUs.form.topicPlaceholder')"
                >
                </v-select>
                <div></div>
              </div>
            </CCol> -->
            <CCol sm="12" class="">
              <CInput
                class="mb-0 inputContactForm"
                :label="$t('faqs.contactUs.form.subject')"
                addLabelClasses="mt-1 "
                :value.sync="$v.contactForm.subject.$model"
                :isValid="!$v.contactForm.subject.$anyError"
                :invalidFeedback="$t('faqs.contactUs.form.validation.requiredFieldText')"
              />
            </CCol>
            <CCol sm="12" class="">
              <h4 class="topicTitle mt-4 mb-3">{{ $t('faqs.contactUs.form.description') }}</h4>
              <textarea class="form-control" v-model="contactForm.description" placeholder="" rows="7"></textarea>
            </CCol>
            <CCol sm="12" class="mt-4">
              <CButton color="primary" :disabled="loading" class="w-100" @click="sendContactForm">
                {{ $t('faqs.contactUs.form.btn') }}
              </CButton>
            </CCol>
          </div>
        </CCol>
      </CRow>
    </CCol>
  </page>
</template>

<script>
import page from './Page.vue'
import vSelect from 'vue-select'
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
import { validationMixin } from 'vuelidate'
import { required, email, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'contact',
  components: {
    page,
    vSelect,
    MenssageAlert,
  },

  mixins: [validationMixin],

  validations: {
    contactForm: {
      fullName: {
        required,
      },
      emailAddress: {
        required,
        email,
      },
      companyName: {
        required,
      },
      phoneNumber: {
        required,
        numeric,
      },
      subject: {
        required,
      },
    },
  },

  data() {
    return {
      loading: false,
      messages: [],
      contactForm: {
        fullName: '',
        emailAddress: '',
        companyName: '',
        phoneNumber: '',
        topic: '',
        subject: '',
        description: '',
      },
      topicOptions: [
        {
          label: 'Example 1',
          value: 'undefined',
        },
        {
          label: 'Example 2',
          value: 'undefined',
        },
        {
          label: 'Example 3',
          value: 'undefined',
        },
      ],
      buttonClicked: false,
    }
  },

  mounted() {
    this.buttonClicked = false
  },

  methods: {
    updateCanCall(value) {
      this.contactForm.canCallAboutServices = value
    },

    sendContactForm() {
      this.$v.$touch()

      if (this.$v.$anyError) return

      this.loading = true
      this.buttonClicked = true
      let organizationId = this.$route.params.organizationId
      let body = this.contactForm
      body.topic = this.contactForm.topic.value
      this.messages = []
      services
        .support(organizationId, body)
        .then((res) => {
          this.messages.push({
            status: 'success',
            text: this.$t('faq.contacat.success.messaage'),
          })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
        .finally(() => {
          this.buttonClicked = false
          this.loading = true
          this.scrollTop()
          setTimeout(() => {
            this.goToFaq()
          }, 3000)
        })

      !$v.contactForm.emailAddress.required ? 'this field is required' : !$v.contactForm.emailAddress.email ? 'this field must be a valid e-mail' : ''
    },

    scrollTop() {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 20)
    },

    goToFaq() {
      this.$router.push({ name: 'help' })
    },
  },
}
</script>

<style lang="scss" scoped>
.topicTitle {
  font-size: 1rem;
  font-weight: 600;
}
.formBlock {
  background-color: #fff;
  padding: 50px 35px;
}

.inputContactForm input {
  border: 1px solid #dee2e6 !important;
}

.formTitle {
  font-size: 24px;
  color: #343a40;
}

.canWeContact {
  padding: 20px;
}

.canCallAboutServices {
  font-weight: 600;
  font-size: 1rem;
}

.btnSend {
  background-color: $primary;
  border-radius: 5px;
  color: #fff;
  width: 100%;
  height: 50px;
  border: 1px solid $primary;
}

.disabled {
  background-color: #a3a3a3;
  border: none;
}
</style>
